import * as tslib_1 from "tslib";
import React from 'react';
import BiClickLogger from '../BiClickClogger';
import { useBiClickLogger } from '../hooks/useBiClickLogger';
var SimpleButton = function (_a) {
    var biData = _a.biData, props = tslib_1.__rest(_a, ["biData"]);
    var setTrackingRef = useBiClickLogger(biData).setTrackingRef;
    return React.createElement("button", tslib_1.__assign({}, props, { ref: setTrackingRef }));
};
SimpleButton.displayName = 'SimpleButton';
/*
If you use the `component` parameter.
You must be sure what the property `ref` implemented inside the component.
Because in this case, the current `ref` will apply to a virtual component
and it's will error.
*/
var BiButton = function (_a) {
    var biData = _a.biData, ButtonComponent = _a.component, props = tslib_1.__rest(_a, ["biData", "component"]);
    if (ButtonComponent) {
        return biData ? (React.createElement(BiClickLogger, { eventData: biData },
            React.createElement(ButtonComponent, tslib_1.__assign({}, props)))) : (React.createElement(ButtonComponent, tslib_1.__assign({}, props)));
    }
    return React.createElement(SimpleButton, tslib_1.__assign({}, props, { biData: biData }));
};
BiButton.displayName = 'BiButton';
export default BiButton;
//# sourceMappingURL=BiButton.js.map